import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Homepage from './components/Homepage';
import Payment from './components/Payment';
import NotFoundPage from './common/NotFoundPage';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import DeliveryFormWrapper from './context/wrappers/DeliveryFormWrapper';


const router = createBrowserRouter([
    {
        path: '/:type?/:payment_type?',
        element: <Homepage />,
        errorElement: <NotFoundPage />,
    },
    {
        path: '/payment/:type?/:payment_type?',
        element: <Payment />,
        errorElement: <NotFoundPage />,
    },
    {
        path: '/service/:type/:payment_type?',
        element: <DeliveryFormWrapper />,
        errorElement: <NotFoundPage />,
    },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(<RouterProvider router={router} />);

